(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a85db1c"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxury-video')) {
    class LuxuryVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-luxury-video-toggle]');

        if (!this.video || !this.toggle) return;

        this.pauseLabel = this.toggle.dataset.pauseLabel;
        this.playLabel = this.toggle.dataset.playLabel;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.pause();
          this.setPaused(true);
        }

        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.video.play();
            this.setPaused(false);
          } else {
            this.video.pause();
            this.setPaused(true);
          }
        });
      }

      setPaused(paused) {
        this.toggle.dataset.paused = paused ? 'true' : 'false';
        this.toggle.setAttribute('aria-label', paused ? this.playLabel : this.pauseLabel);
      }
    }

    customElements.define('luxury-video', LuxuryVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
